import { h as o } from "vue";
import { o as e } from "./DownloadIcon.DHCHRETy.js";
const d = (r, { attrs: t }) => {
  r = { ...e(), ...r };
  const { width: i, height: s } = r;
  return o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 18.558 18.558",
      width: `${i}`,
      height: `${s}`,
      class: r.class ?? "",
      "aria-hidden": t["aria-hidden"] ?? "true"
    },
    o(
      "g",
      {
        fill: "none",
        stroke: `${t["stroke-color"] ?? "#222"}`,
        "stroke-linecap": `${t["stroke-linecap"] ?? "round"}`,
        "stroke-linejoin": `${t["stroke-linejoin"] ?? "round"}`,
        "stroke-width": `${t["stroke-width"] ?? "3"}`
      },
      [
        o("path", {
          d: "m2.121 2.121 14.316 14.316"
        }),
        o("path", {
          d: "M2.121 16.437 16.244 2.121"
        })
      ]
    )
  );
};
export {
  d as l
};
